import React, { Component } from 'react';
import AnimateOnChange from 'react-animate-on-change';
import onClickOutside from 'react-onclickoutside';

import style from './SharingControl.css';

class SharingControl extends Component {
  componentWillMount() {
    this.setState({ toggleList: true, hovered: false });
    this.shareList = [
      {
        name: 'Facebook',
        icon: FacebookSvg(),
        link: 'https://www.facebook.com/sharer/sharer.php?u=',
      },
      {
        name: 'Twitter',
        icon: TwitterSvg(),
        link: 'http://twitter.com/share?url=',
      },
      {
        name: 'Email',
        icon: EnvelopeSvg(),
        link: `mailto:?subject=${encodeURI(document.title)}&body=${encodeURI(
          'Check out this cool 3d virtual world map on Doarama ',
        )}`,
      },
    ];
  }

  getLink(source) {
    const path = window.location.pathname.split('/')[1];
    // if this is an embed path, get the referrer as the url to share
    let url =
      path === 'embed' && document.referrer !== ''
        ? document.referrer
        : window.location.href.replace('/embed/', '/scene/');

    if (source) {
      url = url.replace(/(utm_source=)[^&]+/, `$1${source.toLowerCase()}`);
    }
    return encodeURIComponent(url);
  }

  handleClickOutside() {
    // only close if opened as to all clicks this is always listening
    if (this.state.toggleList) return;
    this.closeMenu();
  }

  closeMenu() {
    this.setState({ toggleList: !this.state.toggleList });
    clearTimeout(this.showTimeout);
    delete this.showTimeout;
  }

  showOptions() {
    if (this.showTimeout) {
      this.setState({ toggleList: !this.state.toggleList });
      clearTimeout(this.showTimeout);
      delete this.showTimeout;
      return;
    }

    this.showTimeout = setTimeout(() => {
      if (this.state.hovered) return;
      this.closeMenu();
    }, 3000);
  }

  showButton() {
    if (this.props.parent === 'footer') {
      return (
        <span
          className={`${this.props.isMobile ? style.mobile : ''} ${style.button}`}
          name='share-alt'
          onClick={() => {
            this.setState({ toggleList: !this.state.toggleList });
            this.showOptions();
          }}
        >
          <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24'>
            <g fill='none' fillRule='evenodd' transform='translate(-7 -8)'>
              <rect width='40' height='40' />
              <path
                stroke='white'
                strokeLinecap='round'
                strokeWidth='2'
                d='M15.5799236,25.2111456 L22.4222912,21.7899618'
                transform='matrix(1 0 0 -1 0 47.001)'
              />
              <path
                stroke='white'
                strokeLinecap='round'
                strokeWidth='2'
                d='M15.5799236,18.2100382 L22.4222912,14.7888544'
              />
              <circle cx='12' cy='20' r='4' stroke='white' strokeLinecap='round' strokeWidth='2' />
              <circle cx='26' cy='27' r='4' stroke='white' strokeLinecap='round' strokeWidth='2' />
              <circle cx='26' cy='13' r='4' stroke='white' strokeLinecap='round' strokeWidth='2' />
            </g>
          </svg>
        </span>
      );
    }
    return null;
  }

  render() {
    return (
      <div className={this.props.parent === 'modal' ? `${style.shareModal} inModal ` : style.shareControl}>
        <div
          className={style.shareList}
          onMouseEnter={() => {
            this.setState({ hovered: true });
          }}
          onMouseLeave={() => {
            this.setState({ hovered: false });
          }}
        >
          <AnimateOnChange
            baseClassName={`${style.shareOptions} menuOptions`}
            animationClassName='hideMenuOptions'
            animate={this.state.toggleList && this.props.parent !== 'modal'}
          >
            {this.shareList.map(s => (
              <span
                key={s.name}
                className={style.shareItem}
                name={s.name}
                onClick={() => {
                  window.open(s.link + this.getLink(s.name));
                  analytics.event({
                    category: 'Share',
                    action: s.name,
                  });
                }}
              >
                {s.icon}
              </span>
            ))}
          </AnimateOnChange>
          {this.showButton()}
        </div>
      </div>
    );
  }
}

/**
 * SVGeeeees
 */

const EnvelopeSvg = () => (
  <svg aria-hidden='true' role='img' viewBox='0 0 512 512'>
    <path
      fill='currentColor'
      d='M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z'
    />
  </svg>
);

const FacebookSvg = () => (
  <svg aria-hidden='true' role='img' viewBox='0 0 264 512'>
    <path
      fill='currentColor'
      d='M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229'
    />
  </svg>
);

const TwitterSvg = () => (
  <svg role='img' viewBox='0 0 512 512'>
    <path
      fill='currentColor'
      d='M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z'
    />
  </svg>
);

export default onClickOutside(SharingControl);
